import React from "react";

export function CountDown({ timeLeft }) {
  return (
    <div className="fixed-top bg-loader text-center smooth-open">
        <h1 className="m-2 text-white big-size">{timeLeft}</h1>
    </div>
  );
}
